type RybbitWindow = Window & {
  rybbit?: {
    event: (name: string, params?: Record<string, string | number>) => void
  }
}

export const trackGoal = (
  name: string,
  params?: Record<string, string | number>,
) => {
  if (typeof window === "undefined") return false
  try {
    const analytics = (window as RybbitWindow).rybbit
    if (!analytics) return false
    analytics.event(name, { pathname: window.location.pathname, ...params })
    return true
  } catch {
    // Analytics must never prevent a visitor from subscribing.
    return false
  }
}
